export const READING_STATE_STORAGE_KEY_PREFIX = 'narrativebench-caret-';
export const getReadingStateStorageKey = (documentId) => `${READING_STATE_STORAGE_KEY_PREFIX}${documentId}`;
export const readingStateSignature = (state) => `${Math.round(state.pos)}:${Math.round(state.scrollTop)}`;
export const parseReadingState = (raw) => {
    if (!raw)
        return null;
    try {
        const parsed = JSON.parse(raw);
        if (typeof parsed.pos !== 'number' || parsed.pos < 0)
            return null;
        const scrollTop = typeof parsed.scrollTop === 'number' && parsed.scrollTop >= 0 ? parsed.scrollTop : 0;
        return { pos: parsed.pos, scrollTop };
    }
    catch {
        return null;
    }
};
export const serializeReadingState = (state) => JSON.stringify({ pos: state.pos, scrollTop: state.scrollTop });
export const selectReadingStateForRestore = (local, remote) => remote ?? local;
export const fetchReadingState = async (apiBase, documentId, token) => {
    const response = await fetch(`${apiBase}/api/documents/${documentId}/reading-state`, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
    if (!response.ok) {
        throw new Error(`Failed to fetch reading state: ${response.status}`);
    }
    const data = (await response.json());
    if (!data.readingState)
        return null;
    return { pos: data.readingState.pos, scrollTop: data.readingState.scrollTop };
};
//# sourceMappingURL=reading-state.js.map